import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { StorageService } from 'src/app/services/internals/storage.service';
import { ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/app/services/repositories/auth.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'src/app/services/repositories/user.service';
import { MatIconModule } from '@angular/material/icon';
import { UserPhotoUrlPipe } from 'src/app/pipes/user-photo-url.pipe';
import { take } from 'rxjs';
import { GestionErreursService } from 'src/app/services/gestion-erreurs.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, IonicModule, RouterModule, TranslateModule, MatIconModule, UserPhotoUrlPipe],
  standalone: true
})
export class HeaderComponent  implements OnInit {
  comptePartage: any;
  currentUser: any;
  constructor(
    private router: Router,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private userService: UserService,
    private storageService: StorageService,
    private gestionErreursService: GestionErreursService
  ) {
    
  }

  async ngOnInit() {
    this.authService.comptePartage$.subscribe(value => {
      this.comptePartage = value;
      this.cdRef.detectChanges(); // au cas où le changement vient d’un autre composant
    });
    this.currentUser = await this.userService.getUserInStorage();
    this.userService.currentUserPhoto$.subscribe(photo => {
      this.currentUser = { ...this.currentUser, photo };
      this.cdRef.detectChanges();
    });

  }

  async closeComptePartage() {
    await this.authService.releaseControl();
    this.router.navigate(['']);
    this.cdRef.detectChanges();
  }

  logout() {
    this.authService.logout().then((req: any) => {
      req.pipe(take(1)).subscribe({
        next: (res: any) => {
          this.storageService.clearAll();
          this.router.navigate(['login']);
        }, 
        error: (err: any) => {
          this.gestionErreursService.handleError(err)
        }
      })
    })
  }
}
